import { useEffect, useRef, useState } from 'react';
import { SectionHeader, Modal, Button } from '@ets/design-system';
import { FormattedMessage, useIntl } from 'react-intl';

import { useDispatch } from '_common/hooks/redux';
import { useModalData } from 'App/ModalContext/ModalContext';
import { setSearchMode, setSearchQuery } from 'Search/redux/SearchPageSlice';
import { closeModal } from 'App/ModalContext/utils';

import { AdvancedFilterRow } from '_common/components';
import { Textarea, TextareaAPI, type TextareaProps } from '_common/lib/components';

import styles from './AdvancedSearchModal.module.scss';
const MODAL = 'AdvancedSearchModal';

const AdvancedSearchModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const textareaRef = useRef<TextareaAPI>(null);

  const data = useModalData('AdvancedSearchModal');

  const [query, setQuery] = useState(data?.initialQuery ?? '');

  useEffect(() => {
    console.log(query);
  }, [query]);

  const close = () => {
    //Clean up local states since modal isn't unmounted
    setQuery('');

    closeModal(MODAL);
  };

  const handleAddQuery = (newQuerySection: string, conditionType: string) => {
    setQuery((prevQuery) => {
      let newQuery = '';

      if (prevQuery) {
        if (conditionType === 'not') {
          newQuery = `${prevQuery} and ${conditionType} ${newQuerySection}`;
        } else {
          newQuery = `${prevQuery} ${conditionType} ${newQuerySection}`;
        }
      } else {
        if (conditionType === 'not') {
          newQuery = `${conditionType} ${newQuerySection}`;
        } else {
          newQuery = newQuerySection;
        }
      }

      //
      textareaRef.current?.setValue(newQuery);
      return newQuery;
    });
  };

  const handleManualQueryChange: TextareaProps['onChange'] = (e) => {
    const target = e.target as HTMLTextAreaElement;
    setQuery(target.value);
  };

  const handleSubmitQuery = () => {
    if (query) {
      dispatch(setSearchMode('advanced'));
      dispatch(setSearchQuery({ query }));
    }

    close();
  };

  return (
    <Modal width="140rem" open close={close} testId="advanced-search">
      <Modal.Header>
        <FormattedMessage id="ADVANCED_SEARCH" />
      </Modal.Header>
      <Modal.Body style={{ overflow: 'visible' }}>
        <SectionHeader margin="0 0 1rem 0" size="m" testId="search-filters">
          <FormattedMessage id="SEARCH_FILTERS" />
        </SectionHeader>
        <AdvancedFilterRow
          type="query"
          onAddQuery={handleAddQuery}
          testId="advanced-search-modal"
        />

        <div className={styles.searchPreview}>
          <SectionHeader size="m" testId="search-preview">
            <FormattedMessage id="SEARCH_PREVIEW" />
          </SectionHeader>
          <Textarea
            ref={textareaRef}
            plainText
            size="m"
            name="query"
            type="text"
            initialContent={query}
            placeholder={intl.formatMessage({ id: 'SEARCH_QUERY_WILL_APPEAR_HERE' })}
            onChange={handleManualQueryChange}
            testId="advanced-search-modal-query-preview"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button size="m" variant="standard" onClick={close} testId="advanced-search-modal-cancel">
          <FormattedMessage id="global.cancel" />
        </Button>
        <Button
          size="m"
          variant="primary"
          onClick={handleSubmitQuery}
          style={{ margin: '0 0 0 1rem' }}
          disabled={!query}
          testId="advanced-search-modal-query-search"
        >
          <FormattedMessage id="global.search" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdvancedSearchModal;
